<template>
  <div class="courses-view">
    <div class="container">

      <div style="height: 2rem"></div>

      <div class="row">
        <img class="mx-auto" src="../assets/kurse.svg" alt="Gehirn">
      </div>

      <div style="height: 2rem"></div>

      <div class="row">
        <div class="col">
          <h1 class="text-center">
            <strong>{{ i18n.title }}</strong>
          </h1>
        </div>
      </div>

      <div style="height: 2rem"></div>

      <div class="row">
        <div class="col">
          <div class="ly-search-bar">
            <input id="search-bar"
                   type="text"
                   v-model="search"
                   :placeholder="i18n.searchPH">
            <i class="icon fas fa-search"></i>
          </div>
        </div>
      </div>
    </div>

    <div style="height: 2rem"></div>

    <div class="ly-bg-grey py-5">
      <div class="container">
        <div class="row">
          <div class="col">

            <ly-course-list :courses="courses" :filter="search">
            </ly-course-list>

          </div> <!-- col -->
        </div> <!-- row -->
      </div> <!-- container -->
    </div>

    <!-- author view -->
    <div class="ly-bg-author py-3 mt-5" v-if="isAuthor">
      <div class="container">
        <div class="row">
          <div class="col">
            <lyCourseEdit></lyCourseEdit>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"

import lyCourseEdit from "@/components/authoring/course-update"
import lyCourseList from "@/components/ly-course-list"

import http from "axios";
import * as i18n from "@/i18n/courses";
import utils from "../misc/utils.js";

export default {
  name: "courses-view",
  mounted() {
    const el =document.querySelector("#search-bar")
    el && el.focus();
    this.$store.commit('setLang', this.$props.lang)
    // this.$router.replace('/courses/'+lang)
    this.fetchCourses();
  },
  props: {
    lang: String,
  },
  watch: {
    'lang': 'fetchCourses'
  },
  data() {
    return {
      courses: [],
      search: "",
    };
  },
  computed: {
    ...mapGetters(["isAuthor"]),
    i18n: function() {
      return i18n[this.$store.state.profile.lang]
    },
  },
  methods: {
    ...utils,

    fetchCourses() {
        http.get(`courses?filter[where][language]=${this.$store.state.profile.lang}&filter[include]=author`)
          .then(({data}) => {
            this.courses = [...data]
          }).catch(err => console.error(err))
    },

/*
    delCourse(name) {
      const { fetchCourses } = this;
      http.delete(`courses/${name}`)
        .catch(err => console.error(err))
        .then(fetchCourses)
    },
*/

  },
  components: {
    lyCourseEdit,
    lyCourseList
  }
}
</script>

<style scoped>
*:focus {
  outline-offset: 5px;
  outline: 2px dashed deepskyblue;
}

.ly-search-bar {
  width: 100%;
  padding: 5px 10px;
  border: 2px solid black;
}
.ly-search-bar input {
  width: 90%;
  font-size: 120%;
  border: none;
}
.ly-search-bar .icon {
  float: right;
  margin: 0.4em;
}

#search-bar:focus {
  outline-offset: 1rem;
}
</style>
